// Shared analytics dashboard scope (state, derived data, helpers) provided to
// the section components as they are extracted into their own files.
import { createContext, useContext } from 'react';

export const AnalyticsContext = createContext(null);
export const useAnalyticsContext = () => useContext(AnalyticsContext);
